import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofPostItNotes = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for Post-it Notes?", 
            answer: "Printingy offers extensive customisation options for Post-it Notes Printing, including sizes, colours, and adhesive strength. Our services support custom sticky note print with logos, vibrant graphics, and tailored layouts. Additional options include lined, grid, or blank note designs to meet various needs."
        },
        { 
            question: "Does Printingy handle bulk orders for Post-it Notes and sticky notes?", 
            answer: "Yes, Printingy specialises in bulk post-it printing, catering to businesses, event organisers, and corporate clients. Bulk printing ensures consistent quality and cost-effective solutions, making it ideal for marketing campaigns, office supplies, or branded gifts."
        },
        { 
            question: "What industries benefit from Post-it Notes printing services?", 
            answer: "Post-it note printing services are widely used in industries such as corporate offices, education, marketing, and events. Businesses use custom post-it note printing for branding, while educational institutions and event planners use personalised sticky note printing for engagement and communication. Printingy provides tailored solutions to meet the unique requirements of each sector."
        },
        { 
            question: "What materials and finishes are available for sticky notes?", 
            answer: "We use high-quality materials for Printing Sticky Notes Pad, including eco-friendly paper and durable adhesives. Finishes such as matte or glossy add to your sticky notes' visual appeal and functionality. These materials ensure your notes maintain their professional appearance and usability over time."
        },
        { 
            question: "Does Printingy provide design assistance for Post-it Notes?", 
            answer: "Yes, our custom sticky note print services include professional design assistance. Whether you have a concept in mind or need creative input, our design team collaborates with you to create visually engaging and functional layouts. From selecting colours to adding logos, we ensure your sticky notes align with your branding."
        },
        { 
            question: "What is the typical turnaround time for Post-it Notes printing?", 
            answer: "Turnaround times for Post-it Notes Printing depend on the size and complexity of the order. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality."
        },
        { 
            question: "Are eco-friendly options available for sticky note printing?", 
            answer: "Printingy is committed to sustainability and offers eco-friendly personalised sticky note printing options. To minimise environmental impact, we use recyclable materials, non-toxic inks, and sustainable production methods. These options are ideal for businesses seeking environmentally responsible solutions."
        },
        { 
            question: "What factors should I consider when ordering sticky notes printing?", 
            answer: "Consider the purpose, design, and intended audience when ordering custom Post-it note printing. Choosing the right size, colour scheme, and adhesive strength ensures your sticky notes are functional and visually appealing. Printingy’s team guides the process to help you create products that achieve your goals."
        },
        { 
            question: "How do I place an order for Post-it Notes printing?", 
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for Post-it Notes Printing, including customisation options. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery."
        },
        { 
            question: "What makes bulk Post-it Notes printing cost-effective?", 
            answer: "Bulk custom sticky note print reduces per-unit costs, making it an economical choice for large-scale projects. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk printing services ensure exceptional value while maintaining professional standards."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Post-it Notes');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Post-it Notes and Sticky Notes Printing Services"
  description="Professional Post-it Notes printing services for businesses. Bulk custom sticky notes print and personalised sticky notes printing with durable designs."
  keywords="Bulk post-it printing,
Custom sticky notes print,
Post-it Notes,
Printing Sticky Notes Pad,
Post-it Notes Printing,
Custom Post-it notes printing,
Personalised sticky notes printing
"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Post-it Notes Printing Services</h1>
              <h2 className="text-muted">
              Custom sticky notes and personalised designs for businesses and branding
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
          Post-it Notes and sticky notes are practical tools for communication and branding, offering versatility for office use, marketing, and client engagement. Printingy specialises in Post-it Notes Printing services, including custom sticky note printing and personalised sticky note printing tailored to your needs.
          </p>
          <p>Our high-quality Printing Sticky Notes Pad services provide vibrant colours, durable adhesive, and professional designs that enhance functionality and visual appeal. Our bulk Post-it printing solutions ensure consistent quality and cost-effectiveness for internal office use, promotional campaigns, or client gifting.

</p>
          <p>With advanced printing technology and flexible customisation options, Printingy delivers premium custom post-it notes printing that aligns with your brand identity and messaging.
          </p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Post-it Notes and Sticky Notes Printing</h2>
                <h3 className="large-hed">High-quality, affordable, and customisable sticky notes for businesses</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Post-it Notes Printing services for professional branding.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom sticky note print solutions for cost-effective campaigns.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable materials and strong adhesive for long-lasting use.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for vibrant colours and sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Eco-friendly materials and non-toxic inks for sustainable solutions.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Personalised designs tailored to your brand identity.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by businesses, marketers, and event organisers nationwide.

                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/postitnotes.jpg" // Path relative to the public folder
                  alt="Custom Post-it Notes printing services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Post-it Notes Delivered On Time </h2>
            <h3 className="small-hed">Focus on your productivity while we handle your sticky notes printing needs</h3>
            <p>At Printingy, we combine advanced printing technology with expert craftsmanship to deliver exceptional custom Post-it notes printing services. Whether you need bulk Post-it printing for office supplies or personalised sticky notes for promotional campaigns, we ensure precision and consistency in every print.</p>
            <p>Our streamlined processes guarantee timely delivery, even for large orders. Partner with Printingy for reliable sticky note solutions that keep your brand front and centre.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofPostItNotes;
